import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const dialogContentWrapper = style({
  display: "grid",
  gap: vars.space.m,
});

export const dialogButtonWrapper = style({
  display: "flex",
  gap: vars.space.xs,
});
